module.exports = __webpack_public_path__ + "img/img_01.394b4b6b.png";